module.exports = __webpack_public_path__ + "img/eth-logo.32926578.svg";